import { useEffect } from "react";

import { useGetTheatreMode, useToggleChatContainer } from "_common/hooks/global";

import Presentation from "./presentation";

const component = ( { broadcastId, sessions, isMobile } ) => {
	const theatreModeToggle   = useGetTheatreMode ();
	const toggleChatContainer = useToggleChatContainer ();

	useEffect ( () => {
		if ( isMobile )
			toggleChatContainer ( true );

	}, [ isMobile ] );

	return (
		<Presentation
			broadcastId       = { broadcastId }
			isMobile          = { isMobile }
			sessions          = { sessions }
			theatreModeToggle = { theatreModeToggle }
		/>
	);
};

export default component;
